<div class="col-md-12 mb-30 ic-page ic-due-page">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-sm-8"><h4 class="mb-0">کنترل‌های میانی آماده اجرا</h4></div>
      </div>

      <form class="card card-statistics mb-30" [formGroup]="FilterForm" (ngSubmit)="ReadData()">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 form-group">
              <label>عنوان قالب کنترل میانی</label>
              <input type="text" class="form-control" formControlName="TemplateTitle" placeholder="جستجو در عنوان قالب IC">
            </div>
            <div class="col-md-2 form-group">
              <label>وضعیت</label>
              <select class="custom-select" formControlName="Status">
                <option value="">همه موارد</option>
                <option value="DUE">سررسید</option>
                <option value="DUE_SOON">نزدیک سررسید</option>
                <option value="OVERDUE">گذشته از سررسید</option>
                <option value="UPCOMING">آینده</option>
                <option value="UNKNOWN">قابل محاسبه نیست</option>
                <option value="IN_PROGRESS">در حال اجرا</option>
                <option value="UNDER_REVIEW">در انتظار بررسی</option>
                <option value="COMPLETED">تکمیل‌شده</option>
                <option value="WAITING_FOR_APPROVAL">در انتظار تأیید</option>
              </select>
            </div>
            <div class="col-md-3 form-group"><label>وضعیت موعد</label><select class="custom-select" formControlName="DueStatus">
              <option value="">همه موعدها</option><option value="UPCOMING">هنوز موعد نیست</option><option value="DUE_SOON">نزدیک موعد</option>
              <option value="DUE">سررسید</option><option value="OVERDUE">گذشته از موعد</option><option value="UNKNOWN">قابل محاسبه نیست</option>
            </select></div>
            <div class="col-md-3 form-group">
              <label>گروه تجهیز</label>
              <select class="custom-select" formControlName="GroupId" (change)="ReadSubGroups()">
                <option [ngValue]="0">همه موارد</option>
                <option *ngFor="let group of GroupList" [ngValue]="group.id">{{ group.title }}</option>
              </select>
            </div>
            <div class="col-md-3 form-group">
              <label>زیرگروه تجهیز</label>
              <select class="custom-select" formControlName="SubGroupId">
                <option [ngValue]="0">همه موارد</option>
                <option *ngFor="let subGroup of SubGroupList" [ngValue]="subGroup.id">{{ subGroup.title }}</option>
              </select>
            </div>
            <div class="col-md-4 form-group">
              <label>کلیدواژه تجهیز</label>
              <input type="text" class="form-control" formControlName="Keyword" placeholder="کد BEHFA، شرح، سازنده یا مدل">
            </div>
            <div class="col-md-4 form-group">
              <label>بازه زمانی سررسید</label>
              <select class="custom-select" formControlName="DueWindow">
                <option value="overdue">گذشته از سررسید</option>
                <option value="today">سررسید امروز</option>
                <option value="upcoming">تا یک هفته آینده</option>
                <option value="next30">روز ۸ تا ۳۰ آینده</option>
                <option value="all">همه موارد مرتبط</option>
              </select>
            </div>
            <div class="col-md-4 form-group pt-4 ic-due-actions">
              <button type="submit" class="btn btn-info" [disabled]="loading"><i class="fa fa-search"></i> جستجو</button>
              <button type="button" class="btn btn-warning" [disabled]="loading" (click)="Clear()"><i class="fa fa-eraser"></i> پاک کردن</button>
              <button type="button" class="btn btn-success" [disabled]="!rows.length" (click)="exportExcel()"><i class="fa fa-file-excel-o"></i> Excel</button>
            </div>
          </div>
        </div>
      </form>

      <div class="row mb-3"><div class="col-sm-12">تعداد رکورد: {{ DataList.length }}</div></div>
      <p class="text-muted">موعد تقویمی مستقل از وضعیت اجرا نمایش داده می‌شود. اجرای باز یا در انتظار بررسی، شروع کنترل جدید را مسدود می‌کند.</p>
      <div *ngIf="FilterForm.value.ScopeWindow !== 'all' || FilterForm.value.ExcludeBlocked" class="text-muted mb-2">محدوده انتخاب‌شده داشبورد نیز اعمال شده است؛ برای حذف آن «پاک کردن» را بزنید.</div>
      <div *ngIf="loading" class="text-center p-3">در حال دریافت اطلاعات...</div>
      <div *ngIf="loadError" class="alert alert-danger" role="alert">{{ loadError }}</div>
      <div class="table-responsive" *ngIf="!loading">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color:#489b39;color:white">
            <tr><th>#</th><th>تجهیز</th><th>کد تجهیز</th><th>گروه</th><th>قالب کنترل میانی</th><th>عنوان آیتم</th><th>دوره و هشدار</th><th>آخرین اجرا</th><th>اجرای بعدی</th><th>وضعیت موعد</th><th>امکانات</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList | paginate: { id: 'IC_DueList_Table', itemsPerPage: 50, currentPage: page, totalItems: DataList.length }; let i=index">
              <td>{{ ((page - 1) * 50) + i + 1 }}</td>
              <td>{{ item.equipmentName || '-' }}<br><small>{{ item.equipmentModel || '-' }}</small></td>
              <td><strong>{{ item.equipmentCode || '-' }}</strong></td>
              <td>{{ item.group || '-' }}<br><small>{{ item.subGroup || '-' }}</small></td>
              <td><strong>{{ item.templateCode || '-' }}</strong><br>{{ item.templateTitle || '-' }}</td>
              <td>{{ item.itemTitle || '-' }}</td>
              <td>{{ item.periodUsed ?? item.periodDays ?? 'ثبت نشده' }} روز<br><small>بازه هشدار: {{ item.warningDays ?? 'ثبت نشده' }} روز</small>
                <small class="d-block" *ngIf="item.periodUsed != null && item.periodUsed !== item.periodDays">تنظیم فعلی دوره: {{ item.periodDays }} روز؛ موعد ذخیره‌شده حفظ شده است.</small></td>
              <td>{{ item.lastExecutionDate ? persianDate(item.lastExecutionDate) : 'بدون سابقه اجرا' }}<small *ngIf="item.lastExecutionId" class="d-block">اجرای شماره {{ item.lastExecutionId }}</small>
                <small *ngIf="item.lastExecutionDate && !item.lastExecutionId" class="d-block">تاریخ ذخیره‌شده؛ شناسه اجرای مرتبط قابل اثبات نیست.</small></td>
              <td [attr.title]="'تاریخ میلادی بازگشتی Backend: ' + (item.nextDueDate || 'ثبت نشده')">{{ persianDate(item.nextDueDate) }}<small class="d-block">شروع هشدار: {{ persianDate(item.warningStartDate) }}</small></td>
              <td><span class="badge" [ngClass]="dueClass(item.dueStatus)">{{ item.dueStatusTitle || statusTitle(item.dueStatus || 'UNKNOWN') }}</span>
                <small class="d-block">{{ daysTitle(item.daysToDue) }}</small>
                <span *ngIf="item.status !== item.dueStatus && item.status !== 'UNKNOWN'" class="badge badge-secondary mt-1">{{ statusTitle(item.status) }}</span></td>
              <td>
                <button *ngIf="isReady(item); else notReady" type="button" class="btn btn-success btn-sm ic-due-execute"
                  [disabled]="!!executingId" (click)="execute(item)">
                  <i class="fa fa-play"></i> {{ executingId === item.assignmentItemId ? 'در حال ایجاد...' : 'اجرا' }}
                </button>
                <ng-template #notReady>—</ng-template>
              </td>
            </tr>
            <tr *ngIf="DataList.length === 0"><td colspan="11">کنترل میانی مرتبطی یافت نشد.</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="IC_DueList_Table" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event"></pagination-controls>
  </div>
</div>
